// ==============start-collection-grid-varinet-select==========

$(document).ready(function() {
  if($(".block__product-description-box").length){
    var descriptionHeight = $(".block__product-description-box").height();
    var activedescriptionHeight = $(".product__description").height();
    if(descriptionHeight < activedescriptionHeight){
      $(".product__description").css("height",descriptionHeight+"px");
      $(".readmore").addClass("hidden");
    }
  }
    $(document).on("change", ".sizef input[type='radio']", function() {
        if(screen.width > 750){
         $(".card__media").find(".block_color-Char").remove();
        }else{
         $(".card__information").find(".block_color-Char").remove();
        }
       
        let dataarr = [];
        $(this).parents(".underline-links-hover").find('.sizef input:checked').each(function() {
            dataarr.push($(this).attr("data-value").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''))
        })
        if($("body").hasClass("temp-collection")){
            if(screen.width > 750){
            let mystr = dataarr.reverse().toString();
            }else{
                let mystr = dataarr.toString();
            }
        }else{
            let mystr = dataarr.reverse().toString();
        }       

        let eqal = dataarr.join('-');
        $(this).parents(".product-card-wrapper").find(".class-select option").each(function() {
            let var1 = $(this).attr("data-value");       
            if (eqal == var1) {
                $(this).trigger("change");
                $(this).prop("selected", true);
            }
            let values = $(this).parents(".class-select").find(":selected").attr("data-id");
            $(this).parents(".underline-links-hover").find(".product-variant-id").attr("value", values);
        });

    })
      $(document).on("click", ".block_size_chart_size label", function() {        
        var $this = $(this)
        if(!$(this).parents(".nosto_element").length){
          if(!$("body").hasClass("temp-product")){
                  setTimeout(function() {
                $this.parents(".product-card-wrapper").find(".quick-add__submit").trigger("click");
            }, 1000) 
          }
        }
      })
    $(document).on("click", ".block_mobile-collecion-add-to-cart-btn", function() {
        let $this = $(this);
        if ($this.hasClass("block_btn-only-single")) {         
            $this.parents(".product-card-wrapper").find(".quick-add__submit").trigger("click");
        } else {    
            let sizeHtml = $(this).parents(".underline-links-hover").find(".block_collection_grid_size .block_size_chart").html();
            $(this).parents(".block_featured-collection").find(".block_fea-collection-size-dropdown-inner-list").html(sizeHtml);
            $(this).parents(".block_featured-collection").find(".block_fea-collection-size-dropdown , .block_fea-collection-size-dropdown-main").toggleClass("active");
            if ($("body").hasClass("temp-article")) {
                $(this).parents(".article-template").find(".block_fea-collection-size-dropdown-inner-list").html(sizeHtml);
                $(this).parents(".article-template").find(".block_fea-collection-size-dropdown , .block_fea-collection-size-dropdown-main").toggleClass("active");
            }
            $("body").addClass(" overflow-hidden");

        }
    })

    $(document).on("click", ".block_featured-collection .block_size_chart_colors input", function() {
        let proImg = $(this).attr("data-img");

        $(this).parents(".product-card-wrapper").find(".card__media img").attr("srcset", proImg + "&width=500")
        // if (proImg.includes("no-image-") == false) {
        //     $(this).parents(".product-card-wrapper").find(".card__media img").attr("srcset", proImg + "&width=500")
        // }
    })

    $(document).on('click', 'body', function(e) {
        var target = e.target;
        if ($(".block_fea-collection-size-dropdown-main").is(e.target)) {
            $("body").removeClass("overflow-hidden")
            $(".block_fea-collection-size-dropdown").removeClass("active");
            $(".block_fea-collection-size-dropdown-main").removeClass("active");
        }
    });
    $(document).on("click", ".block_fea-collection-size-dropdown-inner-list .block_size_chart_size label", function() {
        $(this).parents(".block_featured-collection").find(".block_fea-collection-size-dropdown , .block_fea-collection-size-dropdown-main").toggleClass("active");
        $(this).parents(".article-template").find(".block_fea-collection-size-dropdown , .block_fea-collection-size-dropdown-main").toggleClass("active");
        $("body").removeClass(" overflow-hidden");
    })

    $(document).on("click", ".block_fea-collection-size-dropdown-inner-list .block_size_chart_size", function() {
        let clsbtn = $(this).attr("data-secid");
        $(`.product-card-wrapper .block_size_chart_size[data-secid = '${clsbtn}'] label`).trigger("click");
    })

    $(document).on("click", ".block_mobile-collecion-color-btn", function() {
        $(this).parents(".underline-links-hover").toggleClass("active")
    })

    $(document).on("click", ".block_collection_filter_filter_btn", function() {        
        if (screen.width <= 990) {
            $(".ss__slideout__button").trigger("click");   
        }
        else {        
            $(this).toggleClass("active")           
            $(this).parents(".block_collection-grid").find("#main-collection-filters").toggleClass("active");
        }
    })
    $(document).on("click" , ".block_facets-mobile-header-right , .block_facets-mobile-cancel-button , .block_facets-mobile-apply-button" ,function(){
      $(".ss__overlay").trigger("click")
    })

    $(document).on("change", ".product__info-wrapper .block_size_chart_colors input", function(e) {
        if ($("body").hasClass("temp-product")) {
            e.preventDefault()
            let radioClass = $(this).val();
            $('.product__info-wrapper .product-form__input').find(`option.${radioClass}`).attr('selected', true).siblings().attr('selected', false);
            document.querySelector('.block_product-color_select select').dispatchEvent(new Event('change', {
                'bubbles': true
            }))
        }
    })


    $('.readmore').insertAfter('.product__description');
    $(document).on("click", ".readmore", function(event) {
        event.preventDefault();
        var description = document.querySelector('.product__description');
        if (description.style.height === '') {
            description.style.height = 'auto';
            $(this).find(".button-1-black-title").text("Read less");
        } else if (description.style.height === 'auto') {
            description.style.height = '';
            $(this).find(".button-1-black-title").text('Read more');
        } else {
            description.style.height = '40px';
        }
    });
      if($(".block__product-description-box").height() < 125 ){
        $(".readmore").hide()
      }else{
        $(".readmore").show()
      }
    $(".block_color-Char .block_size_chart_colors:first-child input").trigger("click");
    $(window).on("load", function() {

        if ($("body").hasClass("temp-product")) {
            let colorSelectd = $(".block_product-color_select").find(".select__select").find(":selected").attr("class");
            $(".block_size_chart_colors").find(`input[value ="${colorSelectd}"]`).trigger("click")
        }
      setTimeout(() => {
        $(".block_color-Char .block_size_chart_colors:first-child input").trigger("click");
      } , 500)      
    })
  
    $(document).on("click", ".pagination__item", function() {
      let current_href = location.href;
      let intervalTime =  setInterval(function(){
          $(".block_color-Char .block_size_chart_colors:first-child input").trigger("click");
        },1000);
        setTimeout(() => {
          clearInterval(intervalTime);
        }, 5000) 
     })
})


// ==============end-collection-grid-varinet-select==========

// ==============home-page-collection-grid============
var swiper =   new Swiper(".collection-list-grid-mySwiper", {
  slidesPerView: 3,
  spaceBetween: 10,
  autoHeight: true,
  centerMode: false,  
  loop: true,  
  pagination: {
    el: ".block_section-grid-collection .swiper-pagination",
    clickable: true,
  },
   navigation: {
      nextEl: ".block_section-grid-collection .block_swiper-button-next",
      prevEl: ".block_section-grid-collection .block_swiper-button-prev",
    },
    breakpoints: {
    280: {
      slidesPerView: 1
    },
    320: {
      slidesPerView: 1
    },
    480: {
      slidesPerView: 1
    },
    749: {
      slidesPerView: 2
    },
    989: {
      slidesPerView: 3
    },
    1280: {
      slidesPerView: 3
    }
  }
});



// ===============Menu-drawer-mobile==========

$(document).on("click", ".block_menu-leval-two", function() {
    $(this).parents(".block_menu-leval-two-outer").find(".block_menu-leval-last").slideToggle();
    $(this).toggleClass("active")

})


// ======start-blog-post=====
var mySwiper = new Swiper(".block-post-swiper-container", {
    slidesPerView: 1,
    spaceBetween: 10,
    autoHeight: true,
    centerMode: true,
    // loop:true,
    breakpoints: {
        480: {
            slidesPerView: 1
        },
        749: {
            slidesPerView: 1
        },
        989: {
            slidesPerView: 3
        }
    }
});
// var mySwipernew = new Swiper(".myproductSwiper", {
//       slidesPerView: 1,
//       pagination: {
//         el: ".swiper-pagination",
//         dynamicBullets: true,
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
// });
// ======end-blog-post=====

// ================start-collection-filter-catogory==============

$(document).on("click", ".block_collection-category-firstleval", function() {
    $(this).toggleClass("active");
    $(this).parents(".block_collection-category-top").find(".block_collection-category-top-first").slideToggle();
})

$(document).on("click", ".block_collection-category-secoundleval", function() {
    $(this).toggleClass("active");
    $(this).parents(".block_frist-leval").find(".block_collection-category-top-secound").slideToggle();
})
$(document).on("click", ".block_collection-category-thirdleval", function() {
    $(this).toggleClass("active");
    $(this).parents(".block_collection-category-top-secound").find(".block_collection-category-top-third").slideToggle();
})


$(document).on("click", ".facets__summary", function() {
    $(this).toggleClass("active");
    $(this).parents(".facets__disclosure-vertical").find(".facets__display-vertical").slideToggle();
})

// ================size-chat-js=========

$(document).on("click", ".block_switches-container label", function() {
    $(this).addClass("active").siblings().removeClass("active");
    let switchVal = $(this).attr("data-val");
    $(this).parents(".block_size-chart-inner").find(`.${switchVal}`).removeClass("hidden").siblings().addClass("hidden")
})

$(document).on("click", ".block_size-menu-list-title", function(e) {
    e.preventDefault()
    let href = $(this).attr("href")
    if ($("#" + href).length) {
        var target_offset = $("#" + href).offset().top - 100;
        $('html, body').stop().animate({
            scrollTop: target_offset
        }, 1000);
    }
});

// ===================product-page================
if($(".block_product-size-chart").length){
 $(document).on("click" , ".block_size-guide-text" ,function(){
  $(".block_product-size-chart").addClass("active");
  $("body").addClass("overflow-hidden");
})
$(document).on("click" , ".block_product-size-chart-inner-close" , function(){
  $(".block_product-size-chart").removeClass("active");
  $("body").removeClass("overflow-hidden");
}) 
}

function scrollList(classNames) {
	const sliders = document.querySelectorAll(classNames);
	let isDown = false;
	let startX;
	let scrollLeft;

	sliders.forEach((slider) => {
		slider.addEventListener('mousedown', (e) => {
			isDown = true;
			slider.classList.add('active');
			startX = e.pageX - slider.offsetLeft;
			scrollLeft = slider.scrollLeft;
		});
		slider.addEventListener('mouseleave', () => {
			isDown = false;
			slider.classList.remove('active');
		});
		slider.addEventListener('mouseup', () => {
			isDown = false;
			slider.classList.remove('active');
		});
		slider.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - slider.offsetLeft;
			const walk = (x - startX) * 2; //scroll-fast
			slider.scrollLeft = scrollLeft - walk;
		});
	})
}
scrollList(".block_size-chat-info")
$(window).on("load" , function(){
 
  setTimeout(() => {
    $(".block-redeem-points-inner #loyaltylion").addClass("swiper rewards-swiper")
    $(".block-redeem-points-inner .lion-reward-item--product-cart").addClass("swiper-slide")
    $(".block-redeem-points-inner .lion-rewards-list").addClass("swiper-wrapper")
     var swiper =   new Swiper(".page-account-loyalty .rewards-swiper", {
            slidesPerView: 3,
            spaceBetween: 10,
            autoHeight: true,
            centerMode: false,    
            pagination: {
              el: ".block_loyality-swiper-pagination",
              clickable: true,
            },
             navigation: {
                nextEl: ".block-redeem-points-arrows .block_swiper-button-next ",
                prevEl: ".block-redeem-points-arrows .block_swiper-button-prev",
              },
              breakpoints: {
              280: {
                slidesPerView: 1
              },
              320: {
                slidesPerView: 1
              },
              480: {
                slidesPerView: 1
              },
              749: {
                slidesPerView: 2
              },
              989: {
                slidesPerView: 3
              },
              1280: {
                slidesPerView: 3
              }
            }
      });   
     var swiper =   new Swiper(".page-rewards-club .rewards-swiper", {
            slidesPerView: 3,
            spaceBetween: 10,
            autoHeight: true,
            centerMode: false,    
            pagination: {
              el: ".block_loyality-swiper-pagination",
              clickable: true,
            },
             navigation: {
                nextEl: ".block-redeem-points-arrows .block_swiper-button-next ",
                prevEl: ".block-redeem-points-arrows .block_swiper-button-prev",
              },
              breakpoints: {
              280: {
                slidesPerView: 1
              },
              320: {
                slidesPerView: 1
              },
              480: {
                slidesPerView: 1
              },
              749: {
                slidesPerView: 2
              },
              989: {
                slidesPerView: 3
              },
              1280: {
                slidesPerView: 4
              }
            }
      }); 
      $(".block-redeem-points").removeClass("active")    
  }, 1000)
})


// ============faq-page===============
$('.block_faq-heading').click(function(e) {
    e.preventDefault();
    let $this = $(this);
    $this.toggleClass("active-accordian");
    $this.parents(".block_faq-accordian").find(".block_faq-answer").slideToggle(350);
});

$(document).on("click" , ".block_section-faqs-inner-data" , function(){
  $(this).find(".block_section-faqs-inner-data-answer").slideToggle(350);
  $(this).find(".block_section-faqs-inner-data-icon").toggleClass("active")
})

$(document).on("click" , ".quickorder-button .block__btn-txt" ,function(){
  $(".drawer").addClass("active")
})

$(document).on("click" , ".block_quick-list-header-left" , function(){
  $(this).parents(".quick-order-list-table").find(".quick-order-list__table").slideToggle(350);
  $(this).parents(".quick-order-list-table").toggleClass("active")
})

$(document).on("input",".block__collection-wholesale-search-input",function(){
  var term = $(this).val();
  if (term.length != '') {
    if(term.length >= 3){
      var searchURL = '/search?type=product&q=' + term +"&view=wholesale-quick";      
      $.ajax({
        url: searchURL,
        type: 'GET',
        dataType: 'html',
        success:function(wholesalehtml) {  
          
          $(".block__collection-wholesale-search-input").attr("value" , term)
          $('#product-grid').html($(wholesalehtml).find('#product-grid').html());
          $(".pagination-wrapper").addClass("hidden");

        },
        error: function (error) {
          console.log(error.responseJSON.description);
        }     
      });
    }
  }else{
    var url = $(this).attr("data-url");
    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'html',
      success:function(wholesalehtml) {         
       $('.product-grid').html($(wholesalehtml).find('.product-grid').html());
          $(".pagination-wrapper").removeClass("hidden");
      },
      error: function (error) {
        console.log(error.responseJSON.description);
      }     
    });
  }
});

// ==============search-dropdown============
$(document).on("input" , "#search-input" , function(){
    $(".search-modal__form").attr("action" , "javascript:void(0)")
})
$(document).on("submit" , ".search-modal__form" , function(e){
 e.preventDefault();
 window.location.href = `/collections/all?q=${$(this).find("input").val()}`;
})

// ==============top-bar=========

var swiperBaar = new Swiper('.top_baar-swiper.swiper-container', {
  direction: 'vertical', 
  mousewheel: true,
  slidesPerView: 1,
   autoplay: {
    delay: 5000,
  },
  loop: true
});

if($(".temp-product").length){
  function scrollList(classNames){
    const sliders = document.querySelectorAll(classNames);
    let isDown = false;
    let startX;
    let scrollLeft;

    sliders.forEach( (slider) => {
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mousemove', (e) => {
          if(!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX) * 2; //scroll-fast
          slider.scrollLeft = scrollLeft - walk;
          stop();
      });
    })
  }
  scrollList(".thumbnail-list");
}
// ===============backin-stock-popup====
$(document).on("click" ,".block__klaviyo-button",function(){ 
  $("#klaviyo-bis-iframe").contents().find("body").attr("style","top: 50%; transform: translateY(-25%); position: relative;")
  $("#klaviyo-bis-iframe").contents().find(".modal-title").attr("style","font-weight: 600; text-transform: uppercase; letter-spacing: 0;")
})

// ================flag-js=============
$(document).on("click" , ".block_top-baar-main-left" ,function(){
  $(this).find(".block_top-flag-list").toggleClass("hidden")
})